import { Permissions } from '../components/PermissionsCheck/types';
import { PermissionName } from '../constants/permissionName';

export interface VerifyUserHasRbacPermissions {
  /** List of permissions you want to validate. */
  permissionNames: PermissionName[];
  /** Object with all the User Permissions */
  permissions?: Permissions | null;
  /** Optional: Include an scopeId to restrict the search to a specific Scope.
   *  Omit it to search for Permissions in all Scopes. */
  scopeId?: string;
}

/**
 * @example Search multiple permissions in any Scope
 * const hasReadWriteAccess = ({
 *     permissionNames: ['Archive Read Access', 'Archive Write Access'],
 *     permissions: userPermissions,
 * });
 *
 * @example Search a single permission in a specific Scope
 * const hasReadAccess = getUserHasPermissions({
 *     permissionNames: ['Archive Read Access'],
 *     permissions: userPermissions,
 *     scopeId: 'some-smid',
 * });
 *
 */

export const validateUserHasRbacPermissions = ({
  scopeId,
  permissionNames,
  permissions,
}: VerifyUserHasRbacPermissions) =>
  permissionNames.every((nameToMatch) =>
    Object.entries(permissions ?? {}).some(([userPermissionName, userPermission]) => {
      const isNameMatch = (userPermissionName as unknown as PermissionName) === nameToMatch;
      const isInScope = scopeId ? userPermission.scopes?.some((scope) => scope === scopeId) : true;
      const userIsAllowed = isNameMatch && isInScope;
      return userIsAllowed;
    })
  );
